export async function checkIfShopifyAvailable() {
    fetchShopify()
    setTimeout(() => {
        if (!loadedShopifyCheckout) {
            throw new Error('failed to get head of shopify checkout within 10 seconds')
        }
    }, 10000)
}
let loadedShopifyCheckout = false
async function fetchShopify() {
    await fetch('https://secure.heurekaprints.com/pages/impressum')
    loadedShopifyCheckout = true
}